(function () {
  if (customElements.get('athena-carousel')) return;

class AthenaCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prev = this.querySelector('.a-carousel__btn--prev');
    this.next = this.querySelector('.a-carousel__btn--next');
    if (!this.track || !this.prev || !this.next) return;

    this.loop = this.dataset.loop !== 'false';
    this.originals = Array.from(this.track.children);
    this.settleTimer = null;
    this.setup();

    this.prev.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    window.addEventListener('resize', () => this.measure());
  }

  setup() {
    const overflows = this.track.scrollWidth > this.track.clientWidth + 4;
    if (!overflows) {
      this.classList.add('a-carousel--static');
      return;
    }
    this.classList.remove('a-carousel--static');

    if (this.loop && !this.cloned) {
      this.originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.carouselClone = 'true';
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      });
      this.cloned = true;
    }
    this.measure();
  }

  measure() {
    const gap = this.gap();
    this.baseWidth = this.originals.reduce((sum, node) => {
      return sum + node.getBoundingClientRect().width + gap;
    }, 0);
  }

  gap() {
    return parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
  }

  step() {
    const first = this.track.firstElementChild;
    if (!first) return this.track.clientWidth;
    return first.getBoundingClientRect().width + this.gap();
  }

  move(direction) {
    const perView = Math.max(1, Math.round(this.track.clientWidth / this.step()) - 1);
    const distance = this.step() * perView;
    let target = this.track.scrollLeft + direction * distance;

    if (this.loop && this.baseWidth) {
      if (target >= this.baseWidth) {
        this.track.scrollLeft -= this.baseWidth;
        target -= this.baseWidth;
      } else if (target < 0) {
        this.track.scrollLeft += this.baseWidth;
        target += this.baseWidth;
      }
    }

    this.track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  onScroll() {
    if (!this.loop || !this.cloned || !this.baseWidth) return;
    clearTimeout(this.settleTimer);
    this.settleTimer = setTimeout(() => {
      if (this.track.scrollLeft >= this.baseWidth) {
        this.track.scrollLeft -= this.baseWidth;
      } else if (this.track.scrollLeft < 1) {
        this.track.scrollLeft += this.baseWidth;
      }
    }, 140);
  }
}

  customElements.define('athena-carousel', AthenaCarousel);
})();
